var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"site-logo",attrs:{"href":_vm.market.website + '/',"aria-label":"Tapes To Digital home"}},[_c('img',{staticClass:"site-logo-img",attrs:{"src":_vm.market.logo,"alt":"Tapes To Digital"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }